export const getYearFromStringDateDDmmYYYY = (
  dateString: string | undefined
) => {
  if (!dateString) return;
  return dateString.substring(6, 10);
};
